/* biome-ignore-all lint/suspicious/noConsole: Console logging is intentional in this logger implementation */
import type { Logger } from "./Logger";

type LogLevel = "debug" | "info" | "warn" | "error";

const LOG_LEVEL_PRIORITY: Record<LogLevel, number> = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
};

export class ConsoleLogger implements Logger {
  private bindings: Record<string, unknown> = {};
  private readonly logLevel: LogLevel;

  constructor({ logLevel = "debug" }: { logLevel?: LogLevel } = {}) {
    this.logLevel = logLevel;
  }

  info(...messages: unknown[]) {
    if (LOG_LEVEL_PRIORITY[this.logLevel] > LOG_LEVEL_PRIORITY.info) return;
    console.log(...messages, this.bindings);
  }

  debug(...messages: unknown[]) {
    if (LOG_LEVEL_PRIORITY[this.logLevel] > LOG_LEVEL_PRIORITY.debug) return;
    console.debug(...messages, this.bindings);
  }

  error(error: Error) {
    console.error(error, this.bindings);
  }
  setBindings(bindings: Record<string, unknown>) {
    this.bindings = bindings;
  }
  child(bindings: Record<string, unknown>) {
    const child = new ConsoleLogger({ logLevel: this.logLevel });
    child.setBindings({ ...this.bindings, ...bindings });
    return child;
  }
  warn(warn: Error) {
    if (LOG_LEVEL_PRIORITY[this.logLevel] > LOG_LEVEL_PRIORITY.warn) return;
    console.warn(warn, this.bindings);
  }
}
